import {
  ARTICLE_SCHEMA,
  getBreadCrumbSchema,
} from '../../../../constants/componentStaticData';
import { ISINGLE_POST } from '../types';
import {
  getArticleSchema,
  getArticleSchemaData,
  getBreadCrumbData,
} from '../util';

interface ICMSLayoutSchema {
  postData: ISINGLE_POST;
  pageUrl: string;
  language: string;
}

export const CMSLayoutSchema: React.FC<ICMSLayoutSchema> = ({
  postData,
  pageUrl,
  language,
}) => {
  const articleSchema = getArticleSchema(
    ARTICLE_SCHEMA,
    getArticleSchemaData(postData, pageUrl)
  );

  const BREADCRUMB_DATA = getBreadCrumbData(postData, language);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(getBreadCrumbSchema(BREADCRUMB_DATA)),
        }}
      ></script>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(articleSchema) }}
      ></script>
    </>
  );
};
